import { Card, Button } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../common/PageHeader';
import { LoadingState } from '../../common/LoadingState';
import { ErrorState } from '../../common/ErrorState';
import { useSettings } from '../../../hooks/useSettings';
import { TaxSettings } from './TaxSettings';

export const SettingsPage = () => {
  const navigate = useNavigate();
  const { settings, loading, error, reload, upsertSetting } = useSettings();

  if (loading) return <LoadingState label="Loading settings..." />;
  if (error) return <ErrorState message={error} onRetry={() => void reload()} />;

  return (
    <div>
      <PageHeader title="Settings" subtitle="Exchange rates, tax defaults and audit access" />
      <Card>
        <TaxSettings settings={settings} onSave={(key, value, metadata) => void upsertSetting(key, value, metadata)} />
      </Card>
      <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
        <Button onClick={() => navigate('/settings/exchange-rate')}>Manage exchange rates</Button>
        <Button onClick={() => navigate('/settings/audit')}>Open audit log</Button>
      </div>
    </div>
  );
};
